import React from 'react'
import ReactDOM from 'react-dom/client'
import i18next from 'i18next'
import { I18nextProvider } from 'react-i18next'
import store from 'store'
import { Provider } from 'react-redux'
import axios from 'axios'
import './index.css'
import en from 'locates/en.json'
import zh from 'locates/zh.json'
import App from './App'
import Loading from 'common/loading'
import reportWebVitals from './reportWebVitals'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

declare global {
    interface Window {
        adobeDataLayer: any
        WAGdpr: any
        WCIPCookie: any
    }
}

root.render(<Loading />)

function ALTrackPageLoad(initData: any, production: boolean) {
    const adobeDataLayer = window?.adobeDataLayer
    const isEU = window?.WAGdpr?.isEU()
    if (production) {
        try {
            if (adobeDataLayer && isEU !== undefined) {
                adobeDataLayer.push({
                    event: 'watracking',
                    IsEU: isEU,
                })
                init(initData)
            } else {
                setTimeout(function () {
                    ALTrackPageLoad(initData, production)
                }, 1500)
            }
        } catch (e) {
            console.log('e', e)
        }
    } else {
        init(initData)
    }
}

axios
    .get(
        `https://consvc.hkjc.com/-/Media/sites/LoyaltyEB/media/cmlps/configs?t=${Date.parse(new Date().toString())}`
    )
    .then((result) => {
        ALTrackPageLoad(result.data, true)
    })
    .catch((error) => {
        console.log(error)
    })

const textConfig = (en: any, zh: any, models: any = {}) => {
    for (const page in models) {
        const pageData = models[page] || {}
        if (!en[page]) {
            en[page] = {}
            zh[page] = {}
        }
        en[page] = pageData.en
        zh[page] = pageData.zh
    }
}

function getCookie(cname: string) {
    let name = cname + '='
    let ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) === ' ') {
            c = c.substring(1)
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length)
        }
    }
    return ''
}

const init = (data: any) => {
    textConfig(en, zh, data)
    const cookieLang = getCookie('weblang') || 'en'
    i18next.init({
        fallbackLng: 'en',
        resources: {
            en: {
                translation: en,
            },
            zh: {
                translation: zh,
            },
        },
        lng: cookieLang,
    })

    root.render(
        <React.StrictMode>
            <Provider store={store}>
                <I18nextProvider i18n={i18next}>
                    <App configs={data} />
                </I18nextProvider>
            </Provider>
        </React.StrictMode>
    )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
